import { ReactNode } from 'react';
import styled from 'styled-components';

import { DrawerCloseButton } from './DrawerCloseButton';
import { useDrawerContext } from './context';

const Header = styled.div`
  ${({ theme }) => theme.styles.headings.heading3};
  flex-grow: 1;
  padding: ${({ theme }) => theme.spacing.values.plusHalf};
`;

const Wrapper = styled.div<{ $isScrolledDown: boolean }>`
  border-bottom: ${({ theme }) => theme.spacing.values.single} solid #c3c3c5;
  padding: 0 ${({ theme }) => theme.spacing.values.plusHalf};
  margin: 0 -${({ theme }) => theme.spacing.values.plusHalf};
  display: flex;
  align-items: center;
  ${({ theme, $isScrolledDown }) => ($isScrolledDown ? theme.elevations.smallShadow : null)};
`;

export type DrawerTitleProps = {
  title: ReactNode;
  isExpanded: boolean;
  toolbar?: ReactNode;
  onClose: () => void; // provides additional side effects on close
};

export const DrawerTitle = ({ title, toolbar, onClose, isExpanded }: DrawerTitleProps) => {
  const { contentScrollY: y } = useDrawerContext();

  return (
    <Wrapper $isScrolledDown={y > 0}>
      <Header>{title}</Header>
      {toolbar}
      {isExpanded && <DrawerCloseButton onClose={onClose} />}
    </Wrapper>
  );
};
